import {
    UpdateRoomMemberBannedStatePayload,
    UpdateRoomMemberMutedStatePayload,
} from "@lifeat/shared/data-models/Rooms/RoomModerationTypes";
import { validateRoomId, validateUid } from "@lifeat/shared/util/ArgumentUtil";
import { functions } from "@firebase-local/firebase";
import { ROOMS_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";

export function determineNewMutedStateForUser(
    isUserCurrentlyMuted: boolean,
    isUserMutedDueToReports: boolean,
): [boolean, boolean] {
    let updatedStatus = !isUserCurrentlyMuted;
    let updateInteractingBlockedStatus = false;
    if (isUserMutedDueToReports) {
        updatedStatus = false;
        updateInteractingBlockedStatus = true;
    }
    return [updatedStatus, updateInteractingBlockedStatus];
}

export async function toggleMemberMuteStatus(
    roomId: string,
    memberUid: string,
    newMutedState: boolean,
    updateInteractingBlockedStatus: boolean,
) {
    validateRoomId(roomId);
    validateUid(memberUid);
    if (updateInteractingBlockedStatus && newMutedState) {
        throw new Error("Cannot update interacting blocked status if the member is not muted.");
    }

    const payload: UpdateRoomMemberMutedStatePayload = {
        memberUid: memberUid,
        roomId: roomId,
        updatedState: newMutedState,
        updateReportedMutedStatus: updateInteractingBlockedStatus,
    };
    return functions
        .httpsCallable(ROOMS_FUNCTIONS.ToggleMemberMutedStatus)(payload)
        .catch((e) => {
            alert(`There was an error toggling the mute status. Error: ${e}`);
        });
}

export async function toggleMemberBanStatus(roomId: string, memberUid: string, newBannedState: boolean) {
    validateRoomId(roomId);
    validateUid(memberUid);

    const payload: UpdateRoomMemberBannedStatePayload = {
        memberUid: memberUid,
        roomId: roomId,
        updatedState: newBannedState,
    };
    return functions
        .httpsCallable(ROOMS_FUNCTIONS.ToggleMemberBannedStatus)(payload)
        .catch((e) => {
            alert(`There was an error toggling the banned status. Error: ${e}`);
        });
}
